import React, {useState} from 'react'
import classnames from "classnames";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import {useDealContext} from "../../contexts/DealContext";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import TableHead from "@mui/material/TableHead";
import Collapse from "@mui/material/Collapse";
import {SectionChevron} from "./SectionChevron";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import {NumericFormat} from "react-number-format";
import {DealPageFee} from "./DealPageFee";
import {DealPageCreateCustomFee} from "./DisclosurePDFs/components/DealPageCreateCustomFee";
import {withDocFee} from "../../utils/FeeHelper";


export const DealPageFees = () => {
    const { setDealStateWithUpdate, updateDealResponse, dealState, isHistorical } = useDealContext()
    const [open, setOpen] = useState(false);

    const fees = dealState.formatted_quote.fees.filter((f) => {
        if (f.name === 'Registration Fee') return true;
        if (f.name === 'Acquisition Fee') return true;
        if (f.name === 'Doc Fee') return true;
        return f.amount !== '0'
    })
    const [isAllFinanced, setIsAllFinanced] = useState(fees.every(f => f.is_capped === true))

    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    useDidMountEffect(function setAllFees(){
        let newDealState = structuredClone(dealState)
        const fees = newDealState.formatted_quote.fees

        const newFees = []

        fees.forEach((el, index, array) => {
            const newEl = structuredClone(el)
            newEl.is_capped = isAllFinanced

            newFees.push(newEl)
        })

        newDealState.formatted_quote.fees = newFees
        setDealStateWithUpdate(newDealState, true)
    }, [isAllFinanced])

    if (!(dealState && dealState?.formatted_quote)) return null;

    const isLoading = updateDealResponse?.loading
    // Cash deals are paid in full up front — there is no cap/upfront choice, so
    // the Capped column is dropped entirely.
    const isCash = dealState.is_purchase && dealState.is_one_pay

    const totalFeeAmount = fees.reduce(function(accumulator, fee) {
        return accumulator + Number(fee.amount);
    }, 0)

    return (
        <Box className={classnames("dealPageFees", {
            mobile: isTabletOrMobile,
            open: open,
        })}>
            <Stack
                direction={'row'}
                justifyContent="space-between"
                alignItems="center"
                onClick={() => setOpen(!open)}
                style={{ cursor: 'pointer' }}
                className={'header header-row'}
            >
                <div
                    className={'header-name'}
                >
                    Fees
                </div>
                <Stack
                    direction={'row'}
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <div className={'header-amount'}>
                        <NumericFormat
                            decimalScale={2}
                            value={totalFeeAmount}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />
                    </div>
                    <div>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            <SectionChevron open={open}/>
                        </IconButton>
                    </div>
                </Stack>
            </Stack>
                <Collapse in={open} timeout="auto" mountOnEnter={true}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    className={'header-cell'}
                                    align="left"
                                    width={isTabletOrMobile ? (isCash ? '70%' : '55%') : (isCash ? '85%' : '70%')}
                                >
                                    Name
                                </TableCell>
                                {
                                    !isCash &&
                                    <TableCell
                                        className={'header-cell'}
                                        align="center"
                                        width={'15%'}
                                    >
                                        <div className={'capped-header'}>
                                            <Tooltip title={isAllFinanced ? "All Upfront" : "Cap All"} arrow placement={'top'}>
                                                <Switch
                                                    disabled={isLoading || isHistorical}
                                                    checked={isAllFinanced}
                                                    onChange={() => {
                                                        setIsAllFinanced(!isAllFinanced)
                                                    }}
                                                />
                                            </Tooltip>
                                        </div>
                                    </TableCell>
                                }

                                <TableCell
                                    className={'header-cell'}
                                    align="right"
                                    width={isTabletOrMobile ? '30%' : '15%'}
                                >
                                    Amount
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {/* Adding a fee is a change to the deal — a
                                delivered car has none to add. */}
                            {!isHistorical && <DealPageCreateCustomFee
                                isTabletOrMobile={isTabletOrMobile}
                                dealState={dealState}
                                isLoading={isLoading}
                                isCappingDisabled={isCash}
                                setDealStateWithUpdate={setDealStateWithUpdate}
                            />}
                            {
                                withDocFee(fees).map((fee, idx) => {
                                    return (
                                        <DealPageFee
                                            isTabletOrMobile={isTabletOrMobile}
                                            key={fee.id}
                                            dealState={dealState}
                                            fee={fee}
                                            isLoading={isLoading}
                                            isCappingDisabled={isCash}
                                            setDealStateWithUpdate={setDealStateWithUpdate}
                                        />
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
            </Collapse>
        </Box>
    )
}